/* eslint-disable */
/******************* 友盟埋点 *******************/

// const SITE_ID = 1279528595 // 替换成自己的站点ID          
const SITE_ID = 1279560256 // 替换成自己的站点ID          

export default {
  mounted () {
    this.$nextTick(() => {
      const script = document.createElement('script')
      script.src = `https://v1.cnzz.com/z_stat.php?id=${ SITE_ID }&web_id=${ SITE_ID }`
      script.language = 'JavaScript'
      script.id = 'cnzz'
      document.body.appendChild(script)
    })
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/mixUmeng.js